function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconDeskWheelChair = function IconDeskWheelChair(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "78",
    height: "100",
    viewBox: "0 0 78 100",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_15979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1358 20.4543C31.1566 20.4543 35.2267 16.3841 35.2267 11.3634C35.2267 6.3426 31.1566 2.27246 26.1358 2.27246C21.1151 2.27246 17.0449 6.3426 17.0449 11.3634C17.0449 16.3841 21.1151 20.4543 26.1358 20.4543Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1367 27.2725V54.5452C26.1367 60.8179 31.2276 65.9088 37.5004 65.9088H60.2276L76.1367 88.6361",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1367 45.4541H48.864",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3416 48.4092C7.97798 52.7728 2.27344 61.5228 2.27344 71.591C2.27344 86.0228 13.978 97.7274 28.4098 97.7274C42.8416 97.7274 54.5462 86.0228 54.5462 71.591C54.5462 69.6365 54.3416 67.7274 53.9325 65.9092",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7734 54.4549H57.7507L64.7734 38.6367",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_15979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "78",
    height: "100",
    fill: "white"
  }))));
};